import { render } from "./IngredientDescription.vue?vue&type=template&id=a4104760"
import script from "./IngredientDescription.vue?vue&type=script&lang=js"
export * from "./IngredientDescription.vue?vue&type=script&lang=js"

import "./IngredientDescription.vue?vue&type=style&index=0&id=a4104760&lang=css"

import exportComponent from "/var/www/staging.no-menu.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__